<template>
  <div class="tickets-table">
    <b-table
      :data="tableData"
      :loading="loading"
      hoverable
      striped
      detailed
      detail-key="id"
      detail-transition="fade"
      show-detail-icon
      class="p-3"
    >
      <b-table-column field="email" label="Email" v-slot="props">
        <a class="link" :href="`mailto:${props.row.email}`"
        >  {{ props.row.email }}</a
      >
      
      </b-table-column>

      <b-table-column field="name" label="Name" v-slot="props">
        {{ props.row.name }}
      </b-table-column>

      <b-table-column field="phoneNumber" label="Phone Number" v-slot="props">
        {{ props.row.phoneNumber || "N/A" }}
      </b-table-column>

      <b-table-column
        field="numberOfTickets"
        label="Number of Tickets"
        v-slot="props"
      >
        {{ props.row.numberOfTickets }}
      </b-table-column>

      <template #detail="props">
        <p class="mb-4 has-text-weight-semibold">Additional Details</p>
        <div class="content">
          <p>
            <strong>Affiliate ID:</strong>
            {{ props.row.affiliate_id || "None" }}
          </p>
          <p><strong>Ticket ID:</strong> {{ props.row.ticketId }}</p>
          <p><strong>Total Price:</strong> {{ props.row.totalPrice }}€</p>
        </div>
      </template>

      <template #empty>
        <div class="has-text-centered">No tickets found</div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "TicketsTable",
  props: {
    tickets: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableData() {
      return this.tickets.map((ticketGroup) => ({
        email: ticketGroup.buyerData?.email || "N/A",
        name: ticketGroup.buyerData?.name || "N/A",
        phoneNumber: ticketGroup.buyerData?.phoneNumber || "N/A",
        numberOfTickets: ticketGroup.numberOfTickets || 0,
        affiliate_id: ticketGroup.affiliate_id,
        ticketId: ticketGroup.ticketId,
        totalPrice: ticketGroup.totalPrice,
      }));
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A";

      try {
        const date = new Date(dateString);
        return date.toLocaleDateString("pt-PT", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (error) {
        return "Invalid Date";
      }
    },
  },
};
</script>

<style scoped>
.tickets-table{
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
}
</style>
